import { takeLatest, put, delay } from 'redux-saga/effects';
import axios from 'axios';
import { COMMON_CONTENT_ACTION, COMMON_CONTENT_ACTION_LOADER, HOME_ACTION, HOME_ACTION_LOADER } from "../type"
import { base_url } from '../../components/config';

function* Home(action) {
    try {
        yield put({ type: HOME_ACTION_LOADER, loader: true });

        let id_lang = action.payload?.lang_id || localStorage.getItem('user_lang') || 1;

        const response = yield axios.get(`${base_url}ps_homepage/api`, {
            params: { lang_id: id_lang }
        });

        

        if (response.status === 200) {
            yield put({ type: HOME_ACTION, data: response.data });
        }
    } catch (error) {
        console.error(error);
    } finally {
        yield put({ type: HOME_ACTION_LOADER, loader: false });
    }
}
// function* commonContent(action) {
//     try {
//         yield put({ type: COMMON_CONTENT_ACTION_LOADER, loader: true });

//         let id_lang = action.payload?.lang_id || localStorage.getItem('user_lang') || 1;

//         localStorage.setItem('user_lang', id_lang);

//         const response = yield axios.get(`${base_url}ps_commoncontent/api`, {
//             params: { lang_id: id_lang },
//             withCredentials: true
//         });


//         if (response.status === 200) {
//             yield put({ type: COMMON_CONTENT_ACTION, data: response.data });
//         }

//     } catch (error) {
//     } finally {
//         yield put({ type: COMMON_CONTENT_ACTION_LOADER, loader: false });
//     }
// }
function* commonContent(action) {
    try {
        yield put({ type: COMMON_CONTENT_ACTION_LOADER, loader: true });

        let id_lang = action.payload?.lang_id || localStorage.getItem('user_lang') || 1;
        let params = { lang_id: id_lang };
        
        // ✅ Add address_id if provided
        if (action.payload?.address_id) {
            params.address_id = action.payload.address_id;
            
        }

        if (action.payload?.billing_address_id) {
            params.billing_address_id = action.payload.billing_address_id;
            
        }
        
        // ✅ ADD THIS - Add carrier_id if provided
        if (action.payload?.carrier_id) {
            params.carrier_id = action.payload.carrier_id;
            
        }

        localStorage.setItem('user_lang', id_lang);

        const response = yield axios.get(`${base_url}ps_commoncontent/api`, {
            params: params,
            withCredentials: true
        });

        

        if (response.status === 200) {
            yield put({ type: COMMON_CONTENT_ACTION, data: response.data });
        }

    } catch (error) {
        
    } finally {
        yield put({ type: COMMON_CONTENT_ACTION_LOADER, loader: false });
    }
}
export function* watchCommonContent() {
    yield takeLatest('CcommonContent_sync', commonContent);
}


export function* watchHome() {
    yield takeLatest('Chome_sync', Home);
}
